// removed by extract-text-webpack-plugin
module.exports = {"sectionImg":"_25gYnOj1T9l5EKh47WLGFX","imgPrez":"_1FBzHTuDTLTYB7j8ahN2xB"};


//////////////////
// WEBPACK FOOTER
// ./work/incruizer/styles.module.css
// module id = 727
// module chunks = 0